import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({ variables, breakpoints, palette }) => ({
  notificationPermission: {
    display: 'flex',
    flexDirection: 'column',
    padding: variables?.spacingG,
    borderTopLeftRadius: variables?.radiusRoundedD,
    borderTopRightRadius: variables?.radiusRoundedD,
    boxShadow: variables?.elevation05,
    background: palette?.jet?.containerDefault,
    position: 'fixed',
    bottom: '0',
    zIndex: 1001,
    alignItems: 'center',
    flexShrink: 0,
    gap: variables?.spacingD,
    paddingBottom: variables?.spacingE,
    left: 0,
  },
  notificationPermssionContent: {},
  notificationPermissionHeader: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: variables?.spacingD,
    alignItems: 'center',
  },
  closeIcon: {
    position: 'absolute',
    right: '20px',
    top: '20px',
  },
  notificationPermissionBody: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    flexShrink: 0,
    justifyContent: 'center',
    gap: variables?.spacingD,
    textAlign: 'center',
  },
  notificationPermissionFooter: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-end',
    marginTop: variables?.spacingD,
  },
  notificationPermissionFooterButton: {
    display: 'flex',
  },
}));

export default useStyles;
